module.exports = __webpack_public_path__ + "img/signal_cellular_0_bar.4acc6573.svg";